<template>
	<div class="Impressum">
		<div class="container">
			<h1>{{ $t('navigationImpressum.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<h4>{{ $t('navigationImpressum.subtitle1') }}</h4>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz1') }}
					</div>
					<div>
						{{ $t('navigationImpressum.absatz2') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz4') }}
					</div>
					<h4>{{ $t('navigationImpressum.subtitle2') }}</h4>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz5') }}
						<a href="tel: 09251 8998639">09251 8998639</a>
					</div>
					<h4>{{ $t('navigationImpressum.subtitle3') }}</h4>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz1') }}
					</div>
					<h4>{{ $t('navigationImpressum.subtitle4') }}</h4>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz7a') }}
						<a href="https://sos-p.com">www.sos-p.com</a>
						{{ $t('navigationImpressum.absatz7b') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz8') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz9') }}
					</div>
					<h4>{{ $t('navigationImpressum.subtitle5') }}</h4>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz10') }}
					</div>
					<h4>{{ $t('navigationImpressum.subtitle6') }}</h4>
					<div class="mb-5">
						{{ $t('navigationImpressum.absatz11') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationImpressum.absatz12') }}
					</div>
					<h5 class="mb-3">
						{{ $t('navigationImpressum.absatz13') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz14') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz15') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz16') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz17') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz18') }}
						<div>
							<a
								target="_blank"
								href="https://www.allwallpaper.in/de/rain-at-night-wallpaper-5401.html"
								>https://www.allwallpaper.in/de/rain-at-night-wallpaper-5401.html</a
							>
						</div>
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz19') }}
						<div>
							<a
								target="_blank"
								href="https://wall.alphacoders.com/big.php?i=482897&lang=German"
								>https://wall.alphacoders.com/big.php?i=482897&lang=German</a
							>
						</div>
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz20') }}
						<div>
							<a target="_blank" href="https://github.com/JulietaUla/Montserrat"
								>https://github.com/JulietaUla/Montserrat</a
							>
						</div>
					</div>
					<div class="mb-5">
						{{ $t('navigationImpressum.absatz21') }}
						<div>
							<a
								target="_blank"
								href="https://github.com/RedHatOfficial/RedHatFont"
								>https://github.com/RedHatOfficial/RedHatFont</a
							>
						</div>
					</div>
					<h5 class="mb-3">
						{{ $t('navigationImpressum.absatz22') }}
					</h5>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz23') }}
						<div>
							<a target="_blank" href="http://scripts.sil.org/OFL"
								>http://scripts.sil.org/OFL</a
							>
						</div>
					</div>
					<div class="mb-3">
						{{ $t('navigationImpressum.absatz25') }}
						<div>
							<a target="_blank" href="http://scripts.sil.org/OFL"
								>http://scripts.sil.org/OFL</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Impressum',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_impressum.json'),
			en: require('@/i18n/en/eng_impressum.json')
		}
	}
}
</script>

<style scoped lang="stylus">
a {
	color: red;
}
</style>
